import { api } from "@/api/client";

export type SubProject = {
  id: string;
  projectId: string;
  name: string;
};

export function getSubProjectsByProject(projectId?: string) {
  return api.get<SubProject[]>(`subprojects?projectId=${projectId}`);
}
